// extracted by mini-css-extract-plugin
export default {"refreshIcon":"UpdateButton_refreshIcon__q0P9q","updateText":"UpdateButton_updateText__gGt6i"};